"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWithExpiry = exports.canSeeSecurityModal = void 0;
var LOCAL_PREFERENCES = 'OLX_PREFERENCES_CONTENTMOD';
var MAX_ITEMS = 2;
var getItems = function getItems() {
  var currentItems = localStorage.getItem(LOCAL_PREFERENCES);
  var itemsArray = JSON.parse(currentItems);
  var currentDate = new Date();
  if (!itemsArray || !Array.isArray(itemsArray)) return [];
  var itemsNotExpired = itemsArray.filter(function (item) {
    var expiryDate = new Date(item.expiry);
    return expiryDate >= currentDate;
  });
  return itemsNotExpired;
};
var canSeeSecurityModal = exports.canSeeSecurityModal = function canSeeSecurityModal(chatId) {
  var currentItems = getItems();
  if (currentItems.length >= MAX_ITEMS) return false;
  var alreadySawSecurity = currentItems.some(function (item) {
    return item.value === chatId;
  });
  return !alreadySawSecurity;
};
var setWithExpiry = exports.setWithExpiry = function setWithExpiry(chatId) {
  var now = new Date();
  var oneDayTTL = 1000 * 60 * 60 * 24;
  var currentItems = getItems();
  if (currentItems.length >= MAX_ITEMS) return;
  var item = {
    value: chatId,
    expiry: now.getTime() + oneDayTTL
  };
  currentItems.push(item);
  localStorage.setItem(LOCAL_PREFERENCES, JSON.stringify(currentItems));
};